<ion-buttons slot="end" (click)="presentPopover($event)">
  <ion-icon src="assets/icon/genetic-icons/chat-menu.svg">
  </ion-icon>
  <div class="badge" *ngIf="sharedConfig.userPermissions?.intercom && sharedConfig.intercomBadgeCount && sharedConfig.intercomBadgeCount !== ''">
    <span>{{sharedConfig.intercomBadgeCount}}</span>
  </div>
</ion-buttons>



<ion-popover #popover [isOpen]="isOpen" (didDismiss)="isOpen = false">
  <ng-template>
    <ion-content class="ion-padding">
      <!-- Intercom -->
      <ion-list *ngIf="sharedConfig.userPermissions?.intercom">
        <ion-item mode="ios" (click)="openIntercom()">
          <ion-icon slot="start"  src="assets/icon/toolbar-icons/header-chat.svg">
          </ion-icon>
          <ion-label><b>Chat in app</b></ion-label>
        </ion-item>
      </ion-list>
      <!-- WhatsApp -->
      <ion-list
        *ngIf="sharedConfig.userPermissions?.use_whatsapp_widget && this.sharedConfig.user.broker.whatsapp_number && this.sharedConfig.user.broker.whatsapp_number.length > 2">
        <ion-item mode="ios" (click)="openWhatsApp()">
          <ion-icon slot="start" src="assets/icon/genetic-icons/whatsapp.svg">
          </ion-icon>
          <ion-label><b>Chat in Whatsapp</b></ion-label>
        </ion-item>
      </ion-list>
      <!-- Phone Broker -->
      <ion-list *ngIf="sharedConfig.userPermissions?.phone_broker">
        <ion-item mode="ios" (click)="callBroker()">
          <ion-icon slot="start" class="chat-icon icon-stroke-dark" src="assets/icon/genetic-icons/call-icon.svg">
          </ion-icon>
          <ion-label><b>Contact Broker</b></ion-label>
        </ion-item>
      </ion-list>
      <!-- Phone Insurer -->
      <div *ngIf="sharedConfig.userPermissions?.phone_insurer">
        <ion-list *ngFor="let insurer of sharedConfig.appClientDetail.insurer_contact_details">
          <ion-item (click)="callInsurer(insurer)" mode="ios">
            <ion-icon slot="start" class="chat-icon icon-stroke-dark" src="assets/icon/genetic-icons/call-icon.svg">
            </ion-icon>
            <ion-label><b>{{insurer.description}}</b></ion-label>
          </ion-item>
        </ion-list>
      </div>
      <!-- Email Support -->
      <ion-list *ngIf="!sharedConfig.userPermissions?.intercom">
        <a href={{href_string}}>
          <ion-item mode="ios">
            <ion-icon slot="start" class="chat-icon icon-stroke-dark" name="mail-outline">
            </ion-icon>
            <ion-label><b>Technical Support</b></ion-label>
          </ion-item>
        </a>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-popover>